<template>
    <v-row class="d-flex justify-center mt-5">
        <v-col cols="12" class="teofly_table_block">
            <h5 class="text-center mb-5">Projects in Trash</h5>

            <v-dialog v-model="dialog_restore" width="500" dark overlay-opacity=".5" overlay-color="#333">
                <v-card>
                    <v-card-title class="headline dark justify-center">
                        Are you sure to restore this project?
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-center">
                        <v-btn color="teofly_yes_button" dark @click="restoreProject">Yes</v-btn>
                        <v-btn color="teofly_no_button" dark @click="dialog_restore = false">No</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_remove" width="500" dark overlay-opacity=".5" overlay-color="#333">
                <v-card>
                    <v-card-title class="headline dark justify-center">
                        Are you sure to delete this project?
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-center">
                        <v-btn color="teofly_yes_button" dark @click="deleteProject">Yes</v-btn>
                        <v-btn color="teofly_no_button" dark @click="dialog_remove = false">No</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-data-table
                :headers="headers"
                :items="deleted_projects"
                :sort-by="'id'"
                class="responsive-table teofly-table"
                dark
                hide-default-footer
                :items-per-page="-1"
            >

                <template v-slot:item.space_use="{ item }">
                    <div class="non_break_line">{{ formatBytes(item.space_use) }}</div>
                </template>

                <template v-slot:item.created_at="{ item }">
                    {{ item.created_at != 0 ? connvertToHumanDate(item.created_at) : 'N/A' }}
                </template>

                <template v-slot:item.updated_at="{ item }">
                    {{ item.updated_at != 0 ? connvertToHumanDate(item.updated_at) : 'N/A' }}
                </template>

                <template v-slot:item.layers="{ item }">
                    {{ item.layers.length }}
                </template>

                <template v-slot:item.actions="{ item }">
                    <div class="non_break_line">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small class="mr-2" v-bind="attrs" v-on="on" color="orange" dark @click="restoreItemOpen(item)">Restore</v-btn>
                            </template>
                            <span>Restore Project</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small v-bind="attrs" v-on="on" color="red" dark @click="deleteItemOpen(item)">Delete</v-btn>
                            </template>
                            <span>Delete Project Permanently</span>
                        </v-tooltip>
                    </div>
                </template>

                <template slot="no-data">
                    No projects found
                </template>

            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: "LayerTable",
    data () {
        return {
            dialog_restore: false,
            visible: false,
            dialog_remove: false,
            documentId: 0
        }
    },
    computed: {
        deleted_projects () {
            return this.$store.getters.deleted_projects;
        },
        headers () {
            return [
                { text: '#',            value: 'hashid',                align: 'start' },
                { text: 'Name',         value: 'name' },
                { text: 'Size',         value: 'space_use',             align: 'center' },
                { text: 'Layers',       value: 'layers',                align: 'center' },
                { text: 'I',            value: 'count_image_files',     align: 'center' },
                { text: 'V',            value: 'count_video_files',     align: 'center' },
                { text: 'P',            value: 'count_panorama_files',  align: 'center' },
                { text: 'Create Date',  value: 'created_at',            align: 'center' },
                { text: 'Last Update',  value: 'updated_at',            align: 'center' },
                { text: '',             value: 'actions',               align: 'end' }
            ]
        }
    },
    methods: {
        restoreItemOpen(document){
            this.documentId = document.hashid;
            this.dialog_restore = true;
        },
        deleteItemOpen(document){
            this.documentId = document.hashid;
            this.dialog_remove = true;
        },
        deleteProject(){
            this.$store.dispatch('deleteProjectPerm', this.documentId).then(() => {
                this.dialog_remove = false;
                this.documentId = 0;
                this.$store.dispatch('getDeletedProjects');
            })
            .catch(() => {});
        },
        restoreProject(){
            this.$store.dispatch('restoreProject', this.documentId).then(() => {
                this.dialog_restore = false;
                this.documentId = 0;
                this.$store.dispatch('getDeletedProjects');
                this.$store.dispatch('getProjects');
            })
            .catch(() => {});
        }
    },
    created() {
        this.$store.dispatch('getDeletedProjects')
    }
};
</script>
